import * as React from 'react';
import { Field } from 'formik';
import cx from 'classnames';

export interface FormFieldOption {
  displayName?: string | React.ReactElement;
  icons?: string[];
  className?: string;
  value: string | boolean | number;
  disabled?: boolean;
  hint?: string;
  children?: any;
}

interface RadioGroupProps {
  label?: string;
  name: string;
  optionsArray: FormFieldOption[];
  selected: string | boolean | number;
  onChange: (newValue: string | boolean | number) => void;
  className?: string;
}

export default function RadioGroup(props: RadioGroupProps) {
  return (
    <fieldset className="radio">
      <div className="controls radio_buttons form-group">
        <div>
          {props.optionsArray.map((option, index) => (
            <div className={cx('radio', props.className)} key={index}>
              <label className="choice">
                <Field
                  component="input"
                  type="radio"
                  name={props.name}
                  className={option.className}
                  value={option.value}
                  checked={props.selected === option.value}
                  onChange={() => props.onChange(option.value)}
                  disabled={option.disabled}
                />
                {option.icons && option.icons.map((icon) => <li key={icon} className={icon} />)}
                {option.displayName}
              </label>
              {option.hint && (
                <p>
                  <small>{option.hint}</small>
                </p>
              )}
              {option.children}
            </div>
          ))}
        </div>
      </div>
    </fieldset>
  );
}
